import type { ISEOProps } from "../types/core";

export const PostCreatorPageSEO: ISEOProps = {
  title: "Create Post - Sugar Cribs",
  description:
    "Create and share your content on Sugar Cribs. Upload photos, videos, and connect with your audience.",
};
